export default "__VITE_ASSET__fe5aaea3__"